// roleperms

const state = {
	roleperms: [],

};

export default state;